import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { G4SustainAnalyticsEdit } from "./edit";
import { G4SustainanalyticsNew } from "./new";
import { G4MSustainanalyticsTable } from "./table";

export default function G4SustainAnalytics() {
  useEffect(() => {
    setDocumentTitle("Quantilia | SustainAnalytics");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<G4SustainAnalyticsEdit />} />
      <Route index element={<G4MSustainanalyticsTable />} />
      <Route path="new" element={<G4SustainanalyticsNew />} />
    </Routes>
  );
}
